export const popovers = {
  user5: {
    id: 5,
    avatar: '/demo/avatars/5.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Mary L.',
    fullName: 'Mary Lebowski',
    initials: 'ML',
    color: 'h-yellow',
    location: 'San Diego, CA',
    position: 'Project Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user7: {
    id: 7,
    avatar: '',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Alice C.',
    fullName: 'Alice Carasca',
    initials: 'AC',
    color: 'info',
    location: 'San Diego, CA',
    position: 'Software Engineer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user8: {
    id: 8,
    avatar: '',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Erik K.',
    fullName: 'Erik Kovalsky',
    initials: 'EK',
    color: 'h-purple',
    location: 'New York, NY',
    position: 'Software Engineer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user9: {
    id: 9,
    avatar: '/demo/avatars/9.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Anna B.',
    fullName: 'Anna Baker',
    initials: 'AB',
    color: 'info',
    location: 'San Francisco, CA',
    position: 'UI/UX Designer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user10: {
    id: 10,
    avatar: '/demo/avatars/10.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Henry G.',
    fullName: 'Henry Grobstone',
    initials: 'HG',
    color: 'danger',
    location: 'Miami, FL',
    position: 'Business Analyst',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user11: {
    id: 11,
    avatar: '/demo/avatars/11.jpg',
    badge: '/images/icons/flags/england.svg',
    username: 'Kelly M.',
    fullName: 'Kelly Marston',
    initials: 'KM',
    color: 'success',
    location: 'London, UK',
    position: 'HR Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user12: {
    id: 12,
    avatar: '/demo/avatars/12.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Joshua S.',
    fullName: 'Joshua Stevens',
    initials: 'JS',
    color: 'success',
    location: 'Los Angeles, CA',
    position: 'Backend Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user13: {
    id: 13,
    avatar: '',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Tara S.',
    fullName: 'Tara Svenson',
    initials: 'TS',
    color: 'danger',
    location: 'New York, NY',
    position: 'UI/UX Designer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user14: {
    id: 14,
    avatar: '/demo/avatars/14.jpg',
    badge: '/images/icons/flags/england.svg',
    username: 'Ryan B.',
    fullName: 'Ryan Brentman',
    initials: 'RB',
    color: 'info',
    location: 'London, UK',
    position: 'Web Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user15: {
    id: 15,
    avatar: '/demo/avatars/15.jpg',
    badge: '/images/icons/flags/germany.svg',
    username: 'Hilde V.',
    fullName: 'Hilde Von Strauss',
    initials: 'HV',
    color: 'info',
    location: 'Berlin, Germany',
    position: 'Software Engineer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user16: {
    id: 16,
    avatar: '/demo/avatars/16.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Jason G.',
    fullName: 'Jason Guarank',
    initials: 'JG',
    color: 'danger',
    location: 'Houston, TX',
    position: 'Business Analyst',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user18: {
    id: 18,
    avatar: '/demo/avatars/18.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Esteban C.',
    fullName: 'Esteban Castellanos',
    initials: 'EC',
    color: 'success',
    location: 'Miami, FL',
    position: 'UI/UX Designer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user19: {
    id: 19,
    avatar: '/demo/avatars/19.jpg',
    badge: '/images/icons/flags/germany.svg',
    username: 'Greta K.',
    fullName: 'Greta Kroppfer',
    initials: 'GK',
    color: 'h-yellow',
    location: 'Los Angeles, CA',
    position: 'Sales Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user21: {
    id: 21,
    avatar: '/demo/avatars/21.jpg',
    badge: '/images/icons/flags/england.svg',
    username: 'Elisabeth F.',
    fullName: 'Elisabeth Fisher',
    initials: 'EF',
    color: 'success',
    location: 'London, UK',
    position: 'Mobile Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user22: {
    id: 22,
    avatar: '',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Dwayne H.',
    fullName: 'Dwayne Hicks',
    initials: 'DH',
    color: 'info',
    location: 'Los Angeles, CA',
    position: 'Product Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user23: {
    id: 23,
    avatar: '/demo/avatars/23.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Irina V.',
    fullName: 'Irina Vierbovsky',
    initials: 'IV',
    color: 'info',
    location: 'San Jose, CA',
    position: 'Project Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user24: {
    id: 24,
    avatar: '/demo/avatars/24.jpg',
    badge: '/images/icons/flags/france.svg',
    username: 'Sandrine C.',
    fullName: 'Sandrine Coulart',
    initials: 'SC',
    color: 'info',
    location: 'Lyon, France',
    position: 'HR Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user25: {
    id: 25,
    avatar: '/demo/avatars/25.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Melany W.',
    fullName: 'Melany Wallace',
    initials: 'MW',
    color: 'success',
    location: 'San Diego, CA',
    position: 'Web Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user26: {
    id: 26,
    avatar: '/demo/avatars/26.jpg',
    badge: '/images/icons/flags/australia.svg',
    username: 'Courtney W.',
    fullName: 'Courtney Wilson',
    initials: 'CW',
    color: 'info',
    location: 'Melbourne, AU',
    position: 'Web Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user27: {
    id: 27,
    avatar: '/demo/avatars/27.jpg',
    badge: '/images/icons/flags/spain.svg',
    username: 'Carmen E.',
    fullName: 'Carmen Escudero',
    initials: 'CE',
    color: 'h-yellow',
    location: 'Madrid, Spain',
    position: 'HR Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user28: {
    id: 28,
    avatar: '/demo/avatars/28.jpg',
    badge: '/images/icons/flags/france.svg',
    username: 'Edouard F.',
    fullName: 'Edouard Falant',
    initials: 'EF',
    color: 'success',
    location: 'Paris, France',
    position: 'Web Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user29: {
    id: 29,
    avatar: '/demo/avatars/29.jpg',
    badge: '/images/icons/flags/germany.svg',
    username: 'Hakeem C.',
    fullName: 'Hakeem Calami',
    initials: 'HC',
    color: 'info',
    location: 'Berlin, Germany',
    position: 'Software Engineer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user31: {
    id: 31,
    avatar: '/demo/avatars/31.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Yasseen A.',
    fullName: 'Yasseen Amzi',
    initials: 'YA',
    color: 'warning',
    location: 'New York, NY',
    position: 'Business Analyst',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user32: {
    id: 32,
    avatar: '/demo/avatars/32.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Jonathan K.',
    fullName: 'Jonathan Krugger',
    initials: 'JK',
    color: 'info',
    location: 'Los Angeles, CA',
    position: 'Product Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user33: {
    id: 33,
    avatar: '/demo/avatars/33.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Harvey M.',
    fullName: 'Harvey Miller',
    initials: 'HM',
    color: 'success',
    location: 'Los Angeles, CA',
    position: 'Web Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user34: {
    id: 34,
    avatar: '/demo/avatars/34.jpg',
    badge: '/images/icons/flags/canada.svg',
    username: 'Daniel R.',
    fullName: 'Daniel Redbird',
    initials: 'DR',
    color: 'h-yellow',
    location: 'Toronto, Canada',
    position: 'Web Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user36: {
    id: 36,
    avatar: '/demo/avatars/36.jpg',
    badge: '/images/icons/flags/france.svg',
    username: 'Benoit L.',
    fullName: 'Benoit Leblanc',
    initials: 'BL',
    color: 'h-purple',
    location: 'Paris, France',
    position: 'Software Engineer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user37: {
    id: 37,
    avatar: '/demo/avatars/37.jpg',
    badge: '/images/icons/flags/france.svg',
    username: 'Helmut F.',
    initials: 'HF',
    fullName: 'Helmut Fritz',
    color: 'h-purple',
    location: 'Paris, France',
    position: 'Product Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user38: {
    id: 38,
    avatar: '/demo/avatars/38.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Christie D.',
    fullName: 'Christie Dallas',
    initials: 'CD',
    color: 'info',
    location: 'Los Angeles, CA',
    position: 'Web Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user39: {
    id: 39,
    avatar: '/demo/avatars/39.jpg',
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Alejandro B.',
    fullName: 'Alejandro Badajoz',
    initials: 'AB',
    color: 'h-purple',
    location: 'New York, NY',
    position: 'Business Analyst',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user40: {
    id: 40,
    avatar: '/demo/avatars/40.jpg',
    badge: '/images/icons/flags/france.svg',
    username: 'Jeanne M.',
    fullName: 'Jeanne Marchand',
    initials: 'JM',
    color: 'info',
    location: 'Paris, France',
    position: 'Mobile Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user120: {
    id: 120,
    avatar: null,
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Sara C.',
    fullName: 'Sara Connor',
    initials: 'SC',
    color: 'h-purple',
    location: 'Los Angeles, CA',
    position: 'UI/UX Designer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user121: {
    id: 121,
    avatar: null,
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Naomi L.',
    fullName: 'Naomi Liversky',
    initials: 'NL',
    color: 'success',
    location: 'San Francisco, CA',
    position: 'Frontend Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user122: {
    id: 122,
    avatar: null,
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Betty T.',
    fullName: 'Betty Trejo',
    initials: 'BT',
    color: 'warning',
    location: 'San Diego, CA',
    position: 'Product Manager',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user123: {
    id: 123,
    avatar: null,
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'John D.',
    fullName: 'John Daniels',
    initials: 'JD',
    color: 'info',
    location: 'New York, NY',
    position: 'Web Developer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
  user124: {
    id: 124,
    avatar: null,
    badge: '/images/icons/flags/united-states-of-america.svg',
    username: 'Alan T.',
    fullName: 'Alan Thorne',
    initials: 'AT',
    color: 'success',
    location: 'New York, NY',
    position: 'Software Engineer',
    bio: 'This is a nice user description that we can use as demo content.',
  },
}
